/* @generated */
import * as React from "react";
import classnames from "classnames";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { gapVar, arbitraryChildrenOffsetVar, verticalAlignmentVar, accessoryVerticalAlignmentVar, childrenVerticalAlignmentVar, inlineRecipe, root, startAccessory, endAccessory, childrenOffset, accessory, children } from "./media-object.css.esm.js";
/* empty css                 */import { vars } from "../config/variables.esm.js";
const verticalAlignmentToCssValue = (alignment) => {
  switch (alignment) {
    case "top":
      return "start";
    case "center":
      return "center";
    case "bottom":
      return "end";
    case "baseline":
      return "baseline";
    default:
      return void 0;
  }
};
const MediaObject = ({
  withAccessory,
  className,
  alignY = "top",
  children: children$1,
  accessoryGap = "Micro Large",
  accessoryAlignY,
  childrenAlignY,
  style,
  childrenOffset: childrenOffset$1,
  isInline = false,
  accessoryPosition = "start",
  ...props
}) => {
  const hasAccessory = typeof withAccessory !== "undefined";
  const hasChildrenOffset = typeof childrenOffset$1 !== "undefined";
  const varStyles = assignInlineVars({
    [gapVar]: vars.Spacing[accessoryGap],
    [arbitraryChildrenOffsetVar]: hasChildrenOffset ? vars.Spacing[childrenOffset$1] : void 0,
    [verticalAlignmentVar]: verticalAlignmentToCssValue(alignY),
    [accessoryVerticalAlignmentVar]: verticalAlignmentToCssValue(accessoryAlignY),
    [childrenVerticalAlignmentVar]: verticalAlignmentToCssValue(childrenAlignY)
  });
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      className: classnames(className, inlineRecipe({ isInline }), {
        [root]: hasAccessory,
        [startAccessory]: hasAccessory && accessoryPosition === "start",
        [endAccessory]: hasAccessory && accessoryPosition === "end",
        [childrenOffset]: hasChildrenOffset && hasAccessory
      }),
      style: { ...style, ...varStyles },
      ...props
    },
    hasAccessory && accessoryPosition === "start" ? /* @__PURE__ */ React.createElement("span", { className: classnames(accessory) }, withAccessory) : null,
    /* @__PURE__ */ React.createElement("span", { className: classnames({ [children]: hasAccessory }) }, children$1),
    hasAccessory && accessoryPosition === "end" ? /* @__PURE__ */ React.createElement("span", { className: classnames(accessory) }, withAccessory) : null
  );
};
export {
  MediaObject
};
